import { createClient } from '@supabase/supabase-js';

const url = (import.meta.env.VITE_SUPABASE_URL as string | undefined)?.trim() || undefined;
const anon = (import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined)?.trim() || undefined;

if (!url || !anon) {
  console.warn(
    '[ISBD] VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY manquants. Configurez apps/web/.env',
  );
}

export const supabase = createClient(url || 'http://localhost:54321', anon || 'public-anon-key', {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    // Échange manuel dans AuthCallbackPage uniquement — évite la course
    // detectSessionInUrl + exchangeCodeForSession (erreur PKCE verifier).
    detectSessionInUrl: false,
    flowType: 'pkce',
  },
});

export async function invokeAiFunction<T>(
  name: 'ai-ideation' | 'ai-analyze',
  body: Record<string, unknown>,
): Promise<T> {
  const { data, error } = await supabase.functions.invoke(name, { body });
  if (error) throw error;
  return data as T;
}

export async function invokeEdgeFunction<T>(
  name: string,
  body: Record<string, unknown>,
): Promise<T> {
  const { data, error } = await supabase.functions.invoke(name, { body });
  if (error) throw error;
  if (data && typeof data === 'object' && 'error' in data && (data as { error?: string }).error) {
    throw new Error(String((data as { error: string }).error));
  }
  return data as T;
}
